import React, { type ReactNode } from "react";
import type { BaseProps } from "@purpur/common-types";
import * as RadixLabel from "@radix-ui/react-label";
import c from "classnames/bind";

import styles from "./label.module.scss";

const cx = c.bind(styles);

const rootClassName = "purpur-label";

export type LabelProps = Omit<BaseProps<"label">, "children"> & {
  children: ReactNode;
  disabled?: boolean;
  negative?: boolean;
};

export const Label = ({
  children,
  className,
  disabled,
  negative = false,
  ...props
}: LabelProps) => {
  const classes = cx(className, rootClassName, {
    [`${rootClassName}--disabled`]: disabled,
    [`${rootClassName}--negative`]: negative,
  });

  return (
    <RadixLabel.Root className={classes} {...props}>
      {children}
    </RadixLabel.Root>
  );
};
